export const NAME = "projects/list" as const;
export const PERCENT_INVESTED_TO_SHOW_PROGRESS_BAR = 70 as const;
